import * as React from "react"
import { ImageIcon, FileTextIcon, Combine } from "lucide-react"

import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandShortcut,
} from "@/components/ui/command"

interface CommandMenuProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSelect: (command: string) => void
}

export function CommandMenu({ open, onOpenChange, onSelect }: CommandMenuProps) {
  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "/" && !e.metaKey && !e.ctrlKey) {
        e.preventDefault()
        onOpenChange(true)
      }
    }

    document.addEventListener("keydown", down)
    return () => document.removeEventListener("keydown", down)
  }, [onOpenChange])

  const commands = [
    {
      id: 'photo',
      label: 'Create Photo Node',
      icon: ImageIcon,
      description: 'Add a new photo generation node'
    },
    {
      id: 'describer',
      label: 'Create Describer Node',
      icon: FileTextIcon,
      description: 'Add a new image description node'
    },
    {
      id: 'synthesizer',
      label: 'Create Synthesizer Node',
      icon: Combine,
      description: 'Add a new node to combine and format content from data nodes'
    }
  ]

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Type a command or search..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Create Node">
          {commands.map((command) => (
            <CommandItem
              key={command.id}
              onSelect={() => {
                onSelect(command.id)
                onOpenChange(false)
              }}
            >
              <command.icon className="mr-2 h-4 w-4" />
              <span>{command.label}</span>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  )
}
